import React, { useContext } from 'react'
import { AppContext } from '../context/useAppContext';
import classNames from "classnames";

function Size() {
    const [appState, setAppState] = useContext(AppContext);
 

  const changeIconsize=(size)=>{
    setAppState({
        ...appState,
        size: size,
      });
  }
  return (
    <div>
    <button
      className={classNames("min-w-auto w-32 h-10 bg-blue-300 p-2 rounded-l-md hover:bg-blue-500  text-white font-semibold   transition-all duration-200 ease-in-out",
      { "bg-blue-900": appState.size === "small" })}
      onClick={() => {
        changeIconsize("small");
      }}
    >
      Small
    </button>
    <button
    className={classNames("min-w-auto w-32 h-10 bg-blue-300 p-2 rounded-none hover:bg-blue-500 text-white font-semibold   transition-all duration-200 ease-in-out",
    { "bg-blue-900": appState.size === "medium" })}
     
      onClick={() => {
        changeIconsize("medium");
      }}
    >
      Medium
    </button>
    <button
     className={classNames("min-w-auto w-32 h-10 bg-blue-300 p-2 rounded-r-md hover:bg-blue-500 text-white font-semibold  transition-all duration-200 ease-in-out",
     { "bg-blue-900": appState.size === "large" })}
    
      onClick={() => {
        changeIconsize("large");
      }}
    >
      Large
    </button>
  </div>
  )
}

export default Size